import { t } from 'i18next'

import * as yup from 'yup'

import { IFormModel } from 'types'

/**
 * Form constants
 */
const TITLE = 'title'
const SUBJECT = 'subject'
const DOMAIN = 'domain'
const GRADE_LEVEL = 'grade_level'
const LEVELS = 'levels'
const POINTS_TOTAL = 'points_total'
const IS_PEER_ASSESSMENT_ONLY = 'is_peer_assessment_only'
const RUBRIC_CRITERIONS = 'rubric_criterions'

/**
 * Form model
 */
const formModel = (): IFormModel => {
  return {
    [TITLE]: {
      label: `${t('common.title')}`,
      name: TITLE,
      required: true,
    },
    [SUBJECT]: {
      label: `${t('common.subject')}`,
      name: SUBJECT,
    },
    [DOMAIN]: {
      label: `${t('common.domain')}`,
      name: DOMAIN,
    },
    [GRADE_LEVEL]: {
      label: `${t('common.grade-level')}`,
      name: GRADE_LEVEL,
      required: true,
    },
    [LEVELS]: {
      label: `${t('rubrics.levels')}`,
      name: LEVELS,
      required: true,
    },
    [POINTS_TOTAL]: {
      label: `${t('rubrics.points-total')}`,
      name: POINTS_TOTAL,
      required: true,
    },
    [IS_PEER_ASSESSMENT_ONLY]: {
      label: `${t('rubrics.peer-assessment')}`,
      name: IS_PEER_ASSESSMENT_ONLY
    },
    [RUBRIC_CRITERIONS]: {
      label: `${t('rubrics.criterions')}`,
      name: RUBRIC_CRITERIONS
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [TITLE]: '',
  [SUBJECT]: null,
  [DOMAIN]: null,
  [GRADE_LEVEL]: null,
  [LEVELS]: null,
  [POINTS_TOTAL]: '',
  [IS_PEER_ASSESSMENT_ONLY]: false,
  [RUBRIC_CRITERIONS]: [],
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [TITLE]: yup.string().required(`${t('errors.required-error-message')}`),
    [LEVELS]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),  
    [POINTS_TOTAL]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),  
    [SUBJECT]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`), 
    [DOMAIN]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`), 
    [GRADE_LEVEL]: yup
      .object()
      .nullable()
      .required(`${t('errors.required-error-message')}`),    
    [RUBRIC_CRITERIONS]: yup
    .array()
    .nullable()
    .required(`${t('errors.required-error-message')}`)
  })

export default formModel